import React from 'react';
import Dict from 'dict-lib';
import {getLexemeOptions, setSenses, setPolies} from './../../LexemePage';
import {LexemeUtilities} from './../LexemeHelper';
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";

const updateSenses = ['SET_SENSE'];
var updateClasses = ['subentries'];

export const setDefabs = (id, abstr, descrLanguage) => {
    /*item = LexemeUtilities.encodeUrl(item);*/
    abstr = LexemeUtilities.encodeUrl(abstr);
    if (abstr.length === 0)
        abstr = getLexemeOptions("SENSE_DEFAULT_ABS_SYMBOL");

    return LexemeUtilities.call('/senses/setDefabs/' + id + '/' + abstr + '/' + descrLanguage.replace('-', '^') + '/' + updateSenses);
};

export const setEncy = (id, filename, descrLanguage) => {
    return LexemeUtilities.call('/senses/setEncyclopedicInfos/' + id + '/' + filename + '/' + descrLanguage.replace('-', '^') + '/' + updateSenses);
};

export const changeStatus = (item, status) => {
    return LexemeUtilities.callResetLexemeStatus('/senses/changeStatus/' + item.ids + '/' + status);
};

export const deleteSense = (item) => {
    return LexemeUtilities.callResetTabPages('/senses/deleteSense/' + item.ids + '/' + updateSenses, true);
};

export const deleteEncyclopedicInfos = (item) => {
    return LexemeUtilities.call('/senses/deleteEncyclopedicInfosBySenseId/' + item.ids + '/' + updateSenses, true);
};

export const removeSenseVarLoc = (item, ids) => {
    ids = ids.toString().replace(/,/g, '_');
    return LexemeUtilities.callResetTabPages('/senses/removeSenseVarLoc/' + item.ids + '/' + ids + '/' + updateSenses, true);
};

export const deleteLink = (ids) => {
    return LexemeUtilities.callResetTabPages('/senses/deleteLink/' + ids + '/' + updateSenses);
};

export const hideShowLink = (item, ids) => {
    item = LexemeUtilities.encodeUrl(item);
    return LexemeUtilities.call('/senses/hideShowLink/' + item + '/' + ids + '/' + updateSenses);
}

export const saveNotes = (localSenses) => {
    localSenses = LexemeUtilities.encodeUrl(localSenses);
    return LexemeUtilities.call('/senses/saveNotes/' + localSenses + '/' + updateSenses);
};

export const saveUsages = (item) => {
    var cuId = item.chronological_usage.id;
    var duId = item.domain_usage.id;
    var fuId = item.frequency_usage.id;
    var ruId = item.register_usage.id;

    return LexemeUtilities.callResetTabPages('/senses/saveUsages/' + item.ids + '/' + cuId + '/' + duId + '/' + fuId + '/' + ruId + '/' + updateSenses);
};

export const saveLink = (item, idToLink, type) => {
    return LexemeUtilities.callResetTabPages('/senses/saveLink/' + item.ids + '/' + idToLink + '/' + type + '/' + updateSenses);
};

export const saveDating = (item) => {
    return LexemeUtilities.call('/senses/saveDating/' + item.ids + '/' + item.dating + '/' + updateSenses);
};

export const promoteSenses = (item, langList) => {
    return LexemeUtilities.call('/senses/promoteSenses/' + item.ids + '/' + langList[0].id_lang + '/' + updateSenses);
};

export const spreadSenses = (item, ids) => {
    return LexemeUtilities.call('/senses/spreadSenses/' + item.ids + '/' + ids + '/' + updateSenses);
};

export const addNewLocSense = (item, rootId, langList) => {
    var ids = "";
    var form = "";

    langList.map((item) => {
        form = item.form;
        ids += item.id_lang + "_";
    });

    ids = ids.substring(0, ids.length - 1);

    return LexemeUtilities.callMultipleHighlight('/senses/addNewLocSense/' + item.ids + '/' + rootId + '/' + ids + '/' + updateSenses, 'senseItemLang_');
};

export const savePhrase = (item, langId, phrase, isAssign, pageStatus, rootId, host) => {
    phrase = LexemeUtilities.encodeUrl(phrase);

    const foundExternalCreateEnvironment = LexemeUtilities.foundExternalCreateEnvironment(host);
    //const externalHost = AdministrationUtilities.getAlignmentDictionaryHost();
    const treeTitle = AdministrationUtilities.getTreeTitle();
    //const foundExternalHost = typeof externalHost !== 'undefined' && externalHost !== null && externalHost !== '';

    const path = '/senses/addEditPhrase/' + item.ids + '/' + phrase + '/' + langId + '/' + isAssign + '/' + (foundExternalCreateEnvironment ? treeTitle : 'null') + '/' + updateSenses;

    if (typeof pageStatus !== 'undefined' && pageStatus === 'READ_ONLY_EXTERNAL_CREATE') {
        return LexemeUtilities.callSimple(path, 'SPINNER_MSG_PHRASE_CREATING', host).then((result) => {
            if(result.result === 'WARNING_STEP_FURTHER') {
                LexemeUtilities.showModalMessage(result.result.toLowerCase(), 'PHRASE_EXISTS', 5000);
            } else {
                LexemeUtilities.resetExternal(rootId, result, host);
            }
        });
    } else if (typeof pageStatus !== 'undefined' && pageStatus === 'TRANSLATION_SELECTOR') {
        return LexemeUtilities.callSimple(path, 'SPINNER_MSG_TRANSLATING', host);
    } else {
        return (isAssign ? LexemeUtilities.callResetTabPages(path) : LexemeUtilities.call(path));
    }
};

export const saveTopic = (ids, topic) => {
    if (topic.length === 0)
        topic = null;
    return LexemeUtilities.call('/senses/setTopic/' + ids + '/' + topic + '/' + updateSenses);
};

export const moveSense = (item, idToLink, mantain) => {
    return LexemeUtilities.callSimple('/senses/moveSense/' + item.ids + '/' + idToLink + '/' + mantain + '/' + updateSenses, 'MOVING_WAIT').then(result => {
        if (result.result === 'OK') {
            LexemeUtilities.resetTabPages();
        }
    });
};

export const showHideSense = (item) => {
    return LexemeUtilities.call('/senses/showHide/' + item.ids + '/' + updateSenses);
};

export const addTranslation = (item, translatingId, context) => {
    item = LexemeUtilities.encodeUrl(item);
    const rootEntryId = context.rootEntryId;

    const foundExternalCreateEnvironment = LexemeUtilities.foundExternalCreateEnvironment();
    const externalHost = context.host;

    if (foundExternalCreateEnvironment) {
        return LexemeUtilities.callSimple('/senses/addTranslation/' + item + '/' + translatingId + '/' + rootEntryId + '/' + updateSenses, 'SPINNER_MSG_TRANSLATING', externalHost).then((result) => {
            LexemeUtilities.resetExternal(JSON.parse(result.additionalInfos).startRootId, result);
        });
    } else {
        return LexemeUtilities.callResetTabPages('/senses/addTranslation/' + item + '/' + translatingId + '/' + rootEntryId + '/' + updateSenses);
    }
};

export const setSensesOrder = (ids, subentryIds, isPoly, polies) => {
    return LexemeUtilities.callNoClose('/senses/setSensesOrder/' + ids + '/' + subentryIds);
};

export const saveTitleAndCaption = (item, title, caption, languageDescr) => {
    item = LexemeUtilities.encodeUrl(item);

    if (title.length === 0)
        title = "$_$";
    if (caption.length === 0)
        caption = "$_$";

    return LexemeUtilities.callNoClose('/senses/saveTitleAndCaption/' + item + '/' + title + '/' + caption + '/' + languageDescr + '/');
};